import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import {
    TextField,
    FormControlLabel,
    Checkbox,
    InputLabel,
    FormControl,
    Typography,
    IconButton,
    Select,
    MenuItem,
    Tooltip,
    FormHelperText
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import TagsInput from '../../../collums-components/form/TagsInput';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { MEDICAL_TYPES } from '../../../collums-constants';
import OrganisationsApi from '../../../api/OrganisationsApi';
import HelpIcon from '@material-ui/icons/Info';

const quantityOptions = new Array(20).fill(0).map((el, index) => index + 1);
const expiresAfterTypes = ['days', 'weeks', 'months'];
const minTimeBetweenServicesType = ['days', 'months', 'years'];

function CourseFormGeneral({
    classes,
    validationMessages,
    register,
    control,
    services,
    getServices,
    categories,
    getCoursesCategories,
    setFilterServices,
    isFromOrg,
    allClinics,
    isPackages,
    errors
}) {
    const [organisationData, setOrganisationData] = useState(null);

    useEffect(() => {
        (async () => {
            const organisation = await OrganisationsApi.getOrganisation();
            setOrganisationData(organisation);
        })();
    }, []);
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'additionalServices'
    });

    return (
        <div className={classes.formContent}>
            <div className={classes.formItem}>
                <InputLabel shrink>Name *</InputLabel>
                <TextField
                    style={{ width: '100%', marginTop: 10 }}
                    inputRef={register({ required: validationMessages.required })}
                    name="name"
                    variant="outlined"
                    inputProps={{ readOnly: !isFromOrg && allClinics.length > 1 }}
                    error={!!errors?.name}
                    helperText={errors?.name?.message}
                />
            </div>
            <div className={classes.formItem}>
                <InputLabel shrink>Description</InputLabel>
                <TextField
                    style={{ width: '100%', marginTop: 10 }}
                    inputRef={register}
                    name="description"
                    variant="outlined"
                    multiline
                    rowsMax={3}
                    inputProps={{ readOnly: !isFromOrg && allClinics.length > 1 }}
                />
            </div>
            {!isPackages && (
                <>
                    <Controller
                        render={({ value, onChange }) => (
                            <Autocomplete
                                disabled={!isFromOrg && allClinics.length > 1}
                                className={`${classes.formItem} ${classes.autocomplete}`}
                                onClose={async () => {
                                    setFilterServices({ value: '' });
                                    await getServices({ value: '' });
                                }}
                                options={services}
                                getOptionLabel={option => option.name || ''}
                                getOptionSelected={(option, service) => option.id === service.id}
                                onChange={(e, service) => {
                                    onChange(service);
                                }}
                                clearOnEscape
                                value={value}
                                onInputChange={async (e, value) => {
                                    setFilterServices({ value });
                                    // await getServices();
                                }}
                                renderInput={params => (
                                    <FormControl style={{ width: '100%' }} error={!!errors?.services}>
                                        <InputLabel shrink>Service *</InputLabel>
                                        <TextField
                                            style={{ marginTop: 10 }}
                                            {...params}
                                            variant="outlined"
                                            error={!!errors?.services}
                                        />
                                        {errors?.services && (
                                            <FormHelperText error>{errors.services.message}</FormHelperText>
                                        )}
                                    </FormControl>
                                )}
                                renderOption={option => {
                                    return <p className={classes.autocompleteOptions}>{`${option.name}`}</p>;
                                }}
                            />
                        )}
                        name={'services'}
                        control={control}
                        rules={{ required: validationMessages.required }}
                    />

                    {/* quantity */}
                    <Controller
                        render={({ value, onChange }) => (
                            <Autocomplete
                                disabled={!isFromOrg && allClinics.length > 1}
                                className={`${classes.formItem} ${classes.autocomplete}`}
                                options={quantityOptions}
                                getOptionLabel={option => option.toString()}
                                getOptionSelected={(option, value) => option === value}
                                onChange={(e, value) => {
                                    onChange(value);
                                }}
                                value={value}
                                renderInput={params => (
                                    <FormControl style={{ width: '100%' }} error={!!errors?.quantity}>
                                        <InputLabel shrink>Quantity *</InputLabel>
                                        <TextField
                                            style={{ marginTop: 10 }}
                                            {...params}
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors?.quantity}
                                        />
                                        {errors?.quantity && (
                                            <FormHelperText error>{errors.quantity.message}</FormHelperText>
                                        )}
                                    </FormControl>
                                )}
                                renderOption={option => {
                                    return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                                }}
                            />
                        )}
                        rules={{
                            min: 1,
                            message: validationMessages.minValueOne,
                            required: validationMessages.required
                        }}
                        name="quantity"
                        control={control}
                    />
                </>
            )}

            <Controller
                render={({ value, onChange }) => (
                    <Autocomplete
                        // disabled={!isFromOrg}
                        className={`${classes.formItem} ${classes.autocomplete}`}
                        onClose={async () => {
                            await getCoursesCategories({ name: '' });
                        }}
                        options={categories}
                        getOptionLabel={option => option.name || ''}
                        getOptionSelected={(option, category) => option === category}
                        onChange={(e, category) => {
                            onChange(category);
                        }}
                        clearOnEscape
                        value={value}
                        onInputChange={async (e, value) => {
                            await getCoursesCategories({ name: value });
                        }}
                        renderInput={params => (
                            <FormControl style={{ width: '100%' }} error={!!errors?.category}>
                                <InputLabel shrink>Category *</InputLabel>
                                <TextField
                                    style={{ marginTop: 10 }}
                                    {...params}
                                    variant="outlined"
                                    error={!!errors?.category}
                                />
                                {errors?.category && <FormHelperText error>{errors.category.message}</FormHelperText>}
                            </FormControl>
                        )}
                        renderOption={option => {
                            return <p className={classes.autocompleteOptions}>{`${option.name}`}</p>;
                        }}
                    />
                )}
                name={'category'}
                control={control}
                rules={{ required: validationMessages.required }}
            />

            <div className={classes.halfRow}>
                <Controller
                    render={({ value, onChange }) => (
                        <Autocomplete
                            disabled={!isFromOrg && allClinics.length > 1}
                            className={`${classes.halfItem} ${classes.autocomplete}`}
                            options={quantityOptions}
                            getOptionLabel={option => option.toString()}
                            getOptionSelected={(option, value) => option === value}
                            onChange={(e, value) => {
                                onChange(value);
                            }}
                            value={value}
                            renderInput={params => (
                                <FormControl style={{ width: '100%' }}>
                                    <InputLabel shrink>{isPackages ? 'Package' : 'Course'} expires after *</InputLabel>
                                    <TextField style={{ marginTop: 10 }} {...params} variant="outlined" fullWidth />
                                </FormControl>
                            )}
                            renderOption={option => {
                                return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                            }}
                        />
                    )}
                    rules={{ min: 1, message: validationMessages.minValueOne }}
                    name="expiresAfterQuantity"
                    control={control}
                />
                <Controller
                    render={({ value, onChange }) => (
                        <Autocomplete
                            disabled={!isFromOrg && allClinics.length > 1}
                            className={`${classes.halfItem}  ${classes.autocomplete}`}
                            options={expiresAfterTypes}
                            getOptionLabel={option => option}
                            getOptionSelected={(option, value) => option === value}
                            onChange={(e, value) => {
                                onChange(value);
                            }}
                            value={value}
                            renderInput={params => (
                                <TextField
                                    style={{ marginTop: 10 }}
                                    {...params}
                                    label={''}
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                            renderOption={option => {
                                return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                            }}
                        />
                    )}
                    name="expiresAfterType"
                    control={control}
                />
            </div>

            {organisationData?.isVat0Only && (
                <FormControl className={classes.formItem} variant="outlined" style={{ display: 'inline-block' }}>
                    <InputLabel>Label course as</InputLabel>
                    <Controller
                        name="medical"
                        control={control}
                        style={{ width: 'calc(100% - 20px)' }}
                        as={
                            <Select>
                                <MenuItem key="empty-medical" value="">
                                    &nbsp;
                                </MenuItem>
                                {Object.entries(MEDICAL_TYPES).map(([key, label]) => (
                                    <MenuItem key={key} value={key}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        }
                    ></Controller>
                    <Tooltip
                        placement="right"
                        title={
                            <Typography style={{ fontSize: '14px', display: 'grid' }}>
                                If you wish, label your courses as cosmetic or medical to help with your reporting.
                                <br />
                                This label can be changed on the invoice at checkout by clicking on the circle icon.
                                <br />
                                If you have selected &quot;All my sales have 0% tax&quot; in Settings, changing this
                                label will have no effect on the tax on the invoice. If you have NOT made this
                                selection, changing the label on the invoice will change the tax (0% for medical, 20%
                                for cosmetic).
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>
                </FormControl>
            )}

            <FormControlLabel
                className={classes.formItem}
                label="Expiry countdown starts on date of 1st redemption rather than date of purchase"
                control={
                    <Controller
                        disabled={!isFromOrg && allClinics.length > 1}
                        control={control}
                        name="startValidityOnRedemption"
                        render={({ onChange, onBlur, value, ref }) => (
                            <Checkbox
                                disabled={!isFromOrg && allClinics.length > 1}
                                onBlur={onBlur}
                                onChange={e => onChange(e.target.checked)}
                                checked={value}
                                inputRef={ref}
                                defaultValue={value || false}
                            />
                        )}
                    />
                }
            />
            <div className={classes.halfRow} style={{ display: 'none', marginLeft: 10 }}>
                <Controller
                    render={({ value, onChange }) => (
                        <Autocomplete
                            className={`${classes.halfItem} ${classes.autocomplete}`}
                            style={{ marginTop: 20 }}
                            options={quantityOptions}
                            getOptionLabel={option => option.toString()}
                            getOptionSelected={(option, value) => option === value}
                            onChange={(e, value) => {
                                onChange(value);
                            }}
                            disabled={!isFromOrg || true}
                            value={value}
                            renderInput={params => (
                                <FormControl style={{ width: '100%' }}>
                                    <InputLabel shrink>Min time between services</InputLabel>
                                    <TextField
                                        style={{ marginTop: 10 }}
                                        {...params}
                                        label={''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                    <Typography>Coming soon</Typography>
                                </FormControl>
                            )}
                            renderOption={option => {
                                return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                            }}
                        />
                    )}
                    rules={{ min: 1, message: validationMessages.minValueOne }}
                    name="minTimeBetweenServices"
                    control={control}
                />
                <Controller
                    render={({ value, onChange }) => (
                        <Autocomplete
                            disabled={!isFromOrg || true}
                            className={`${classes.halfItem}  ${classes.autocomplete}`}
                            options={minTimeBetweenServicesType}
                            getOptionLabel={option => option}
                            getOptionSelected={(option, value) => option === value}
                            onChange={(e, value) => {
                                onChange(value);
                            }}
                            value={value}
                            renderInput={params => <TextField {...params} label={''} variant="outlined" fullWidth />}
                            renderOption={option => {
                                return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                            }}
                        />
                    )}
                    name="minTimeBetweenServicesType"
                    control={control}
                />
            </div>

            {isPackages && (
                <>
                    <div className={classes.formContentRow} style={{ marginTop: 20 }}>
                        <Typography variant="h4" className={classes.sectionName}>
                            Choose the services for your package
                            <IconButton
                                onClick={() => {
                                    append({
                                        service: null,
                                        quantity: null
                                    });
                                }}
                                className={classes.addCircle}
                                style={{ marginTop: 0, marginBottom: 0, padding: '0 0 0 10px' }}
                            >
                                <AddCircleIcon style={{ fontSize: 30, color: '#3083EC' }} />
                            </IconButton>
                        </Typography>
                    </div>

                    <Controller
                        render={({ value, onChange }) => (
                            <Autocomplete
                                disabled={!isFromOrg && allClinics.length > 1}
                                className={`${classes.formItem} ${classes.autocomplete}`}
                                onClose={async () => {
                                    setFilterServices({ value: '' });
                                    await getServices({ value: '' });
                                }}
                                options={services}
                                getOptionLabel={option => option.name || ''}
                                getOptionSelected={(option, service) => option.id === service.id}
                                onChange={(e, service) => {
                                    onChange(service);
                                }}
                                clearOnEscape
                                value={value}
                                onInputChange={async (e, value) => {
                                    setFilterServices({ value });
                                    // await getServices();
                                }}
                                renderInput={params => (
                                    <FormControl style={{ width: '100%' }}>
                                        <InputLabel shrink>Service *</InputLabel>
                                        <TextField style={{ marginTop: 10 }} {...params} variant="outlined" />
                                    </FormControl>
                                )}
                                renderOption={option => {
                                    return <p className={classes.autocompleteOptions}>{`${option.name}`}</p>;
                                }}
                            />
                        )}
                        name={'services'}
                        control={control}
                        rules={{ required: validationMessages.required }}
                    />

                    {/* quantity */}
                    <Controller
                        render={({ value, onChange }) => (
                            <Autocomplete
                                disabled={!isFromOrg && allClinics.length > 1}
                                className={`${classes.formItem} ${classes.autocomplete}`}
                                options={quantityOptions}
                                getOptionLabel={option => option.toString()}
                                getOptionSelected={(option, value) => option === value}
                                onChange={(e, value) => {
                                    onChange(value);
                                }}
                                value={value}
                                renderInput={params => (
                                    <FormControl style={{ width: '100%' }}>
                                        <InputLabel shrink>Quantity *</InputLabel>
                                        <TextField style={{ marginTop: 10 }} {...params} variant="outlined" fullWidth />
                                    </FormControl>
                                )}
                                renderOption={option => {
                                    return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                                }}
                            />
                        )}
                        rules={{
                            min: 1,
                            message: validationMessages.minValueOne,
                            required: validationMessages.required
                        }}
                        name="quantity"
                        control={control}
                    />

                    {fields.map((field, index) => {
                        return (
                            <div key={field.id} className={classes.formContent}>
                                {/* Pole dla "service" */}
                                <Controller
                                    render={({ value, onChange }) => (
                                        <Autocomplete
                                            disabled={!isFromOrg && allClinics.length > 1}
                                            className={`${classes.formItem} ${classes.autocomplete}`}
                                            onClose={async () => {
                                                setFilterServices();
                                                await getServices({ value: '' });
                                            }}
                                            options={services}
                                            getOptionLabel={option => option.name || ''}
                                            getOptionSelected={(option, service) => option.id === service.id}
                                            onChange={(e, service) => {
                                                onChange(service);
                                            }}
                                            clearOnEscape
                                            value={value}
                                            onInputChange={async (e, value) => {
                                                setFilterServices({ value });
                                                // await getServices();
                                            }}
                                            renderInput={params => (
                                                <FormControl style={{ width: '100%' }}>
                                                    <InputLabel shrink>Service *</InputLabel>
                                                    <TextField
                                                        style={{ marginTop: 10 }}
                                                        {...params}
                                                        variant="outlined"
                                                    />
                                                </FormControl>
                                            )}
                                            renderOption={option => {
                                                return (
                                                    <p className={classes.autocompleteOptions}>{`${option.name}`}</p>
                                                );
                                            }}
                                        />
                                    )}
                                    name={`additionalServices[${index}].service`}
                                    control={control}
                                    rules={{ required: validationMessages.required }}
                                />

                                {/* Pole dla "quantity" */}
                                <Controller
                                    render={({ value, onChange }) => (
                                        <Autocomplete
                                            disabled={!isFromOrg && allClinics.length > 1}
                                            className={`${classes.formItem} ${classes.autocomplete}`}
                                            options={quantityOptions}
                                            getOptionLabel={option => option.toString()}
                                            getOptionSelected={(option, value) => option === value}
                                            onChange={(e, value) => {
                                                onChange(value);
                                            }}
                                            value={value}
                                            renderInput={params => (
                                                <>
                                                    <FormControl style={{ width: '80%' }}>
                                                        <InputLabel shrink>Quantity *</InputLabel>
                                                        <TextField
                                                            style={{ marginTop: 10 }}
                                                            {...params}
                                                            variant="outlined"
                                                        />
                                                    </FormControl>
                                                    <IconButton onClick={() => remove(index)} style={{ marginTop: 5 }}>
                                                        <DeleteOutlineOutlinedIcon
                                                            className={classes.deleteIcon}
                                                            style={{ color: 'red' }}
                                                        />
                                                    </IconButton>
                                                </>
                                            )}
                                            renderOption={option => {
                                                return <p className={classes.autocompleteOptions}>{`${option}`}</p>;
                                            }}
                                        />
                                    )}
                                    name={`additionalServices[${index}].quantity`}
                                    control={control}
                                    rules={{
                                        min: {
                                            value: 1,
                                            message: validationMessages.minValueOne
                                        },
                                        required: validationMessages.required
                                    }}
                                />
                            </div>
                        );
                    })}
                </>
            )}

            <div className={classes.formContentRow} style={isPackages ? { marginTop: 60 } : {}}>
                <TagsInput disabled={!isFromOrg && allClinics.length > 1} name="tags" control={control} />
            </div>
        </div>
    );
}

export default CourseFormGeneral;
